import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import ReCAPTCHA from 'react-google-recaptcha';
import { sendContactForm, validateContactForm } from '../../http/Actions/ContactoAction';

const ContactPage = () => {
  // Estados para formulario
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    acceptTerms: false
  });
  
  const [formErrors, setFormErrors] = useState({});
  const [formStatus, setFormStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaKey, setRecaptchaKey] = useState(1);

  // Manejar cambio en reCAPTCHA
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    if (formErrors.recaptcha) {
      setFormErrors({
        ...formErrors,
        recaptcha: ''
      });
    }
  };

  // Manejar cambios en inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: ''
      });
    }
  };

  // Función para resetear el formulario
  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: '',
      acceptTerms: false
    });
    setRecaptchaKey(prevKey => prevKey + 1);
    setRecaptchaToken(null);
  };

  // Manejar envío de formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateContactForm(formData, recaptchaToken, setFormErrors)) {
      sendContactForm(formData, recaptchaToken, setFormStatus, setIsSubmitting, resetForm)
        .catch(error => {
          console.error('Error:', error);
        });
    }
  };

  // Función para volver al formulario después de un envío exitoso
  const handleNewMessage = () => {
    setFormStatus('');
  };

  return (
    <>
      <Helmet>
        <title>Contacto | Stupid Comedy</title>
        <meta name="description" content="Contáctanos para resolver dudas, sugerir comediantes o compartir tus ideas para Stupid Comedy, la plataforma de streaming especializada en comedia chilena." />
      </Helmet>
      
      <section className="py-12 bg-gradient-to-b from-black to-gray-900 text-white min-h-screen">
        <div className="container mx-auto px-4 max-w-4xl">
          {/* Encabezado */}
          <div className="mb-12 border-b border-cyan-500 pb-4">
            <motion.h1 
              className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-teal-500"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Contacto
            </motion.h1>
            <div className="flex items-center mt-4 text-gray-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <span>Estamos para ayudarte</span>
            </div>
          </div>

 <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12">
            {/* Información de contacto */}
            <div className="md:col-span-2">
              <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg border-l-4 border-cyan-500 h-full">
                <h2 className="text-xl font-semibold mb-6 text-cyan-300">Información de contacto</h2>
                
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="bg-cyan-900 bg-opacity-30 p-3 rounded-lg mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-white">Email</h3>
                      <a href="mailto:contacto@stupidcomedy.tv" className="text-gray-300 hover:text-cyan-300 transition-colors">
                        contacto@stupidcomedy.tv
                      </a>
                    </div>
                  </div>
                  {/*}
                  <div className="flex items-start">
                    <div className="bg-cyan-900 bg-opacity-30 p-3 rounded-lg mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-white">Teléfono</h3>
                      <p className="text-gray-300">+56 9 </p>
                    </div>
                  </div>
                  */}
                  <div className="flex items-start">
                    <div className="bg-cyan-900 bg-opacity-30 p-3 rounded-lg mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-white">Ubicación</h3>
                      <p className="text-gray-300">Santiago, Chile</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="bg-cyan-900 bg-opacity-30 p-3 rounded-lg mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-white">Horario de atención</h3>
                      <p className="text-gray-300">Lunes a Viernes: 08:30 - 18:00</p>
                    </div>
                  </div>
                </div>
                
                <div className="mt-10">
                  <h3 className="text-lg font-medium mb-4 text-cyan-300">Síguenos</h3>
                  <div className="flex space-x-4">
                    <a href="https://www.instagram.com/stupidcomedy.tv/" className="bg-gray-700 hover:bg-cyan-800 p-3 rounded-full transition-colors" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    </a>
                    {/*}
                    <a href="https://twitter.com/stupidcomedy" className="bg-gray-700 hover:bg-cyan-800 p-3 rounded-full transition-colors" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                      </svg>
                    </a>
                    <a href="https://facebook.com/stupidcomedy" className="bg-gray-700 hover:bg-cyan-800 p-3 rounded-full transition-colors" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                      </svg>
                    </a>
                    <a href="https://youtube.com/stupidcomedy" className="bg-gray-700 hover:bg-cyan-800 p-3 rounded-full transition-colors" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                      </svg>
                    </a>*/}
                  </div>
                </div>
              </div>
            </div>
            
            {/* Formulario de contacto */}
            <div className="md:col-span-3">
              <div className="p-6 bg-gray-800 bg-opacity-50 rounded-xl shadow-lg border-l-4 border-cyan-500">
                <h2 className="text-xl font-semibold mb-6 text-cyan-300">Envíanos un mensaje</h2>
                
                {formStatus === 'success' ? (
                  <motion.div 
                    className="bg-teal-900 bg-opacity-40 border border-teal-500 rounded-lg p-6 text-center"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="flex justify-center mb-4">
                      <div className="rounded-full bg-teal-800 p-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-teal-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">¡Mensaje enviado con éxito!</h3>
                    <p className="text-gray-300 mb-4">
                      Gracias por contactarnos. Nos pondremos en contacto contigo lo antes posible.
                    </p>
                    <button 
                      className="px-6 py-2 bg-teal-600 rounded-lg hover:bg-teal-700 transition-colors"
                      onClick={handleNewMessage}
                    >
                      Enviar otro mensaje
                    </button>
                  </motion.div>
                ) : formStatus === 'error' ? (
                  <motion.div 
                    className="bg-red-900 bg-opacity-40 border border-red-500 rounded-lg p-6 text-center"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="flex justify-center mb-4">
                      <div className="rounded-full bg-red-800 p-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">¡Error al enviar el mensaje!</h3>
                    <p className="text-gray-300 mb-4">
                      Ha ocurrido un error al enviar tu mensaje. Por favor, inténtalo de nuevo más tarde.
                    </p>
                    <button 
                      className="px-6 py-2 bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
                      onClick={handleNewMessage}
                    >
                      Intentar nuevamente
                    </button>
                  </motion.div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-5">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label htmlFor="name" className="block text-gray-300 mb-2">Nombre *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          className={`w-full py-3 px-4 rounded-lg bg-black bg-opacity-50 text-white placeholder-gray-500 border ${formErrors.name ? 'border-red-500' : 'border-gray-700'} focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent`}
                          placeholder="Tu nombre"
                        />
                        {formErrors.name && (
                          <p className="text-red-500 text-sm mt-1">{formErrors.name}</p>
                        )}
                      </div>
                      
                      <div>
                        <label htmlFor="email" className="block text-gray-300 mb-2">Email *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          className={`w-full py-3 px-4 rounded-lg bg-black bg-opacity-50 text-white placeholder-gray-500 border ${formErrors.email ? 'border-red-500' : 'border-gray-700'} focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent`}
                          placeholder="tu@email.com"
                        />
                        {formErrors.email && (
                          <p className="text-red-500 text-sm mt-1">{formErrors.email}</p>
                        )}
                      </div>
                    </div>
                    
                    <div>
                      <label htmlFor="subject" className="block text-gray-300 mb-2">Asunto *</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        className={`w-full py-3 px-4 rounded-lg bg-black bg-opacity-50 text-white placeholder-gray-500 border ${formErrors.subject ? 'border-red-500' : 'border-gray-700'} focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent`}
                        placeholder="¿Sobre qué quieres contactarnos?"
                      />
                      {formErrors.subject && (
                        <p className="text-red-500 text-sm mt-1">{formErrors.subject}</p>
                      )}
                    </div>
                    
                    <div>
                      <label htmlFor="message" className="block text-gray-300 mb-2">Mensaje *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows={5}
                        className={`w-full py-3 px-4 rounded-lg bg-black bg-opacity-50 text-white placeholder-gray-500 border ${formErrors.message ? 'border-red-500' : 'border-gray-700'} focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent resize-none`}
                        placeholder="Escribe tu mensaje aquí..."
                      ></textarea>
                      {formErrors.message && (
                        <p className="text-red-500 text-sm mt-1">{formErrors.message}</p>
                      )}
                    </div>
                    
                    <div className="flex items-start">
                      <input
                        type="checkbox"
                        id="acceptTerms"
                        name="acceptTerms"
                        checked={formData.acceptTerms}
                        onChange={handleInputChange}
                        className="mt-1"
                      />
                      <label htmlFor="acceptTerms" className="ml-2 text-gray-300 text-sm">
                        Acepto los <a href="/terminos-y-condiciones" className="text-cyan-400 hover:text-cyan-300 transition-colors">términos y condiciones</a> y la <a href="/politica-de-privacidad" className="text-cyan-400 hover:text-cyan-300 transition-colors">política de privacidad</a> *
                      </label>
                    </div>
                    {formErrors.acceptTerms && (
                      <p className="text-red-500 text-sm -mt-3">{formErrors.acceptTerms}</p>
                    )}
                    
                    {/* reCAPTCHA con clave para forzar re-renderizado */}
                    <div className="flex justify-center">
                      <ReCAPTCHA
                        key={recaptchaKey}
                        sitekey={process.env.REACT_APP_GOOGLE_RECAPTHA_SITE_KEY}
                        onChange={handleRecaptchaChange}
                        theme="dark"
                      />
                    </div>
                    {formErrors.recaptcha && (
                      <p className="text-red-500 text-sm text-center">{formErrors.recaptcha}</p>
                    )}
                    
                    <div className="pt-4">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full py-3 px-6 rounded-lg font-medium flex items-center justify-center transition-all duration-300 ${
                          isSubmitting 
                            ? 'bg-gray-600 cursor-not-allowed' 
                            : 'bg-gradient-to-r from-cyan-600 to-teal-600 hover:from-cyan-700 hover:to-teal-700'
                        }`}
                      >
                        {isSubmitting ? (
                          <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Enviando...
                          </>
                        ) : (
                          'Enviar mensaje'
                        )}
                      </button>
                    </div>
                    
                    <p className="text-gray-400 text-sm text-center mt-4">
                      Los campos marcados con * son obligatorios
                    </p>
                  </form>
                )}
              </div>
            </div>
          </div>
          
          {/* Sección adicional - Preguntas rápidas/FAQ */}
          <div className="mt-16 p-6 bg-cyan-900 bg-opacity-20 rounded-xl border border-cyan-700 max-w-3xl mx-auto">
            <h2 className="text-xl font-semibold mb-6 text-center text-cyan-300">Preguntas frecuentes</h2>
            <p className="text-center text-gray-300 mb-6">
              Revisa nuestras preguntas frecuentes para encontrar respuestas rápidas a tus consultas.
            </p>
            <div className="flex justify-center">
              <a href="/faq" className="px-8 py-3 bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-bold rounded-lg hover:from-cyan-700 hover:to-teal-700 transition-all text-center">
                Ver preguntas frecuentes
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;